// extracted by mini-css-extract-plugin
module.exports = {"inputswitch_dark_theme_checked":"InputSwitch_inputswitch_dark_theme_checked__2-w_d","inputswitch_dark_theme_unchecked":"InputSwitch_inputswitch_dark_theme_unchecked__3zBy8"};